module.exports = __webpack_public_path__ + "static/img/Joinbanner.116ed4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Joinbanner.png
// module id = 208
// module chunks = 1